import { defaultHttpClient } from '../../httpClient';

export const postMemberRequestsAvailability = (
  marketSno: number,
  type?: number,
) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: `/api/v2/markets/${marketSno}/member-requests/`,
      data: {
        type: type ?? 0,
      },
    })
    .then(result => result.data);
};
